import {AiTwotonePhone} from "react-icons/ai";
import {FaMapMarkerAlt} from "react-icons/fa";
import {FormattedMessage} from "react-intl";
import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";

import "./style.scss";

const ContactDetails = ({addresses, phones}) => {
    if (!addresses || !phones)
        return;

    return (
        <div className="contact-details-request">
            {phones?.length > 0 &&
                <>

                    {phones?.map((item) => (
                        <div key={item.id} className="contact-details-request-items-item mt-2">
                            <div className="contact-details-request-items-item-icon">
                                <AiTwotonePhone/>
                            </div>
                            <a
                                href={contactMethodsLinks(item.type, item.value)}
                                rel="noreferrer"
                                target="_blank"
                                className="d-flex align-items-center"
                            >
                        <span>
                            {item.value}
                        </span>
                                <small>
                                    ({item.title})
                                </small>
                            </a>
                        </div>
                    ))}
                </>
            }

            {addresses?.length > 0 && addresses?.map(address => (
                <div className="contact-details-request-items-item mt-2">
                    <div className="contact-details-request-items-item-icon">
                        <FaMapMarkerAlt/>
                    </div>
                    <div className=" flex-column align-items-start">
                        <p className="address-text m-0" dangerouslySetInnerHTML={{
                            __html: address?.text
                        }}/>

                        {address?.postal_code &&
                            <p className="address-text mb-0">
                                <FormattedMessage id="postalCode"/>:
                                {address?.postal_code}
                            </p>
                        }
                    </div>
                </div>
            ))
            }
        </div>
    );
};

export default ContactDetails;